import React from 'react';
import { Form, Input, Button, Space } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import type { TFunction } from 'i18next';

interface ContactsFormSectionProps {
  t: TFunction;
}

const ContactsFormSection: React.FC<ContactsFormSectionProps> = ({ t }) => {
  return (
    <Form.List name="contacts">
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name, ...restField }) => (
            <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
              <Form.Item
                {...restField}
                name={[name, 'name']}
                rules={[{ required: true, message: t('common:validation.required') }]}
              >
                <Input placeholder={t('common:fields.name')} />
              </Form.Item>
              <Form.Item
                {...restField}
                name={[name, 'email']}
                rules={[{ type: 'email', message: t('common:validation.email') }]}
              >
                <Input placeholder={t('common:fields.email')} />
              </Form.Item>
              <Form.Item
                {...restField}
                name={[name, 'phone']}
                rules={[{ required: true, message: t('common:validation.required') }]}
              >
                <Input placeholder={t('common:fields.phone')} />
              </Form.Item>
              <MinusCircleOutlined onClick={() => remove(name)} />
            </Space>
          ))}
          <Form.Item>
            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
              {t('common:actions.addContact')}
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>
  );
};

export default ContactsFormSection; 